// @flow

import React                        from 'react';
import { Switch, Route }            from 'react-router-dom';
import NotFound                     from 'components/common/notFound/notFound.js';
import InsuranceInquiry             from './InsuranceInquiry';
import SpecialDeals                 from 'containers/specialDeals/index';
import Settings                     from 'containers/settings/index';
import CompanyBranding              from './CompanyBranding';
import Help                         from './help/index';

const Routes = () => (
  <Switch>
    <Route exact path='/' component={InsuranceInquiry} />
    <Route exact path='/special-deals' component={SpecialDeals} />
    <Route exact path='/settings' component={Settings} />
    <Route path='/company-branding/:companySeoName/:companyAppId' component={CompanyBranding} />
    <Route exact path='/help' component={Help} />

    <Route component={NotFound} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/components/main/routes.js